'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _ShareInput = require('../../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _UISearchInput = require('../../input/UISearchInput');

var _UISearchInput2 = _interopRequireDefault(_UISearchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UITypeaheadSearch = _react2.default.createClass({
  displayName: 'UITypeaheadSearch',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    className: _react.PropTypes.string,
    Input: _react.PropTypes.func.isRequired,
    style: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      Input: _UISearchInput2.default
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        Input = _props.Input,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['className', 'Input', 'style']);

    return _react2.default.createElement(
      'div',
      {
        className: (0, _reactUtils.classNames)('private-search-control__wrapper', className),
        style: style
      },
      _react2.default.createElement(Input, rest)
    );
  }
});

exports.default = (0, _ShareInput2.default)(UITypeaheadSearch);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/typeahead/search/UITypeaheadSearch.js
// module id = 161
// module chunks = 0